export default __webpack_public_path__ + "static/media/SWT1380.34I-35044_-23149_0.2216e87f.jpg";